module.exports = __webpack_public_path__ + "html/select-option.template.html";